module.exports = __webpack_public_path__ + "static/media/31-6.e1344230.mp3";